// extracted by mini-css-extract-plugin
export default {"fade-message":"DailyQuizFinishedUpsell_fade-message__9N3tr","hidden":"DailyQuizFinishedUpsell_hidden__cGxcf","visible":"DailyQuizFinishedUpsell_visible__3jooo"};